import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { AppIconButton } from './ui';

interface InvoiceSearchFilterProps {
  searchQuery: string;
  searchCriteria: string;
  onSearchChange: (query: string) => void;
  onCriteriaChange: (criteria: string) => void;
  onClear: () => void;
}

const InvoiceSearchFilter: React.FC<InvoiceSearchFilterProps> = ({
  searchQuery,
  searchCriteria,
  onSearchChange,
  onCriteriaChange,
  onClear
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="search-criteria-label">Search By</InputLabel>
        <Select
          labelId="search-criteria-label"
          id="search-criteria"
          value={searchCriteria}
          label="Search By"
          onChange={(e) => onCriteriaChange(e.target.value)}
        >
          <MenuItem value="none">
            <em>None</em>
          </MenuItem>
          <MenuItem value="invoiceNumber">Invoice Number</MenuItem>
          <MenuItem value="orderNumber">Order Number</MenuItem>
          <MenuItem value="customerName">Customer Name</MenuItem>
          <MenuItem value="customerPhone">Customer Phone</MenuItem>
          <MenuItem value="tableNumber">Table Number</MenuItem>
        </Select>
      </FormControl>

      {searchCriteria !== 'none' && (
        <TextField
          size="small"
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={`Enter ${getCriteriaLabel(searchCriteria)}...`}
          sx={{ minWidth: 250 }}
          InputProps={{
            startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
            endAdornment: searchQuery && (
              <AppIconButton
                icon={<ClearIcon fontSize="small" />}
                tooltip="Clear search"
                variant="ghost"
                size="small"
                onClick={onClear}
                sx={{ mr: -1 }}
              />
            )
          }}
        />
      )}
    </Box>
  );
};

/**
 * Get display label for search criteria
 */
function getCriteriaLabel(criteria: string): string {
  const labels: Record<string, string> = {
    invoiceNumber: 'invoice number',
    orderNumber: 'order number',
    customerName: 'customer name',
    customerPhone: 'phone number',
    tableNumber: 'table number'
  };
  return labels[criteria] || criteria;
}

export default InvoiceSearchFilter;
